import dogCamera from './dogcamera.png?base64';
import dogExam from './dogexam.png?base64';

export const cardIcons = {
  dogCamera,
  dogExam
};

export type CardIcon = keyof typeof cardIcons;
